<template>
  <div
    v-if="hotelInfo.tripadvisor_data?.ranking_data"
    class="flex"
  >
    <div class="trip-advisor rounded-2xl">
      <div class="trip-advisor-rating">
        <div class="flex justify-start items-center mb-4">
          <div class="trip-advisor-rating__icon">
            <img
              src="@packages/icons/tripadvisor-logo-round-green.png"
              alt="Tripadvisor"
            />
          </div>
          <h4
            class="m-0"
            data-i18n="tripadvisor"
          >
            {{ $t('tripadvisor') }}
          </h4>
        </div>
      </div>
      <h5 class="trip-advisor-total">
        {{ hotelInfo.tripadvisor_data?.ranking_data?.ranking_string }}
      </h5>
      <div class="flex items-center mb-2">
        <img
          class="-ml-2"
          :src="washUrl(hotelInfo.tripadvisor_data?.rating_image_url)"
          :alt="$t('tripadvisorTitle')"
        />
        <a
          class="ml-2 c-text-gray link-underline"
          :href="washUrl(hotelInfo.tripadvisor_data?.web_url)"
          target="_blank"
          data-i18n="tripadvisorNumberOfReviews"
        >{{ $t('tripadvisorNumberOfReviews', { reviews: hotelInfo.tripadvisor_data?.num_reviews }) }}</a>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  hotelInfo: {
    type: Object,
    required: true,
  },
})

const washUrl = (url) => {
  return (url || '').replace('http:', 'https:')
}
</script>

<style lang="scss" scoped>
.trip-advisor {
  background-color: $tripadvisor-bg;
  width: 100%;
  height: fit-content;
  padding: 30px 35px;
  margin-bottom: 1rem;

  @media (min-width: theme('screens.lg')) {
    width: max-content;
  }
}

.trip-advisor-rating__icon {
  width: 34px;
  height: 34px;
}
</style>